import React, { useEffect } from "react";
import Intercom from '@intercom/messenger-js-sdk';
import Landing from "./pages/landing.jsx";
import Booking from "./pages/booking.jsx";
import MyCart from "./pages/myCart.jsx";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import AppLayout from "./layouts/AppLayout.jsx";
import NotFound from "./pages/404.jsx";
import AuthLayout from "./layouts/AuthLayout.jsx";
import Login from "./pages/login.jsx";
import Otp from "./pages/otp.jsx";
import SignUp from "./pages/signUp.jsx";
import CreatePin from "./pages/createPin.jsx";
import Checkout from "./pages/checkout.jsx";
import ForgotPassword from "./pages/forgotPassword.jsx";
import SuccessfulBooking from "./pages/successfulBooking.jsx";
import AquaZone from "./pages/aquaZone.jsx";
import MyPurchases from "./pages/myPurchases.jsx";
import AquaZoneProduct from "./pages/aquaZoneProduct.jsx";
import TagManager from "react-gtm-module";
import FailedBooking from "./pages/failedBooking.jsx";
import ReactGA from "react-ga4";
import ComingSoon from "./pages/comingSoon.jsx";

if (process.env.REACT_APP_GTM_ID) {
  const tagManagerArgs = {
    gtmId: process.env.REACT_APP_GTM_ID,
  };
  TagManager.initialize(tagManagerArgs);
}

//Google Analytics Measurement ID
ReactGA.initialize("G-VPPP6ZDWXC");

Intercom({
  app_id: 'tcacfciz'
});

const App = () => {
  let lwwUAT = '635634bc7aafee47dc652cdb';
  let lwwProd = '63671cce7024902b00cf36af';
  return (
    <Routes>
      <Route path="app" element={<AppLayout />}>
        <Route path="cart" element={<MyCart />} />
        <Route path="aqua" element={<AquaZone />} />
        <Route path="aquaProduct/:id" element={<AquaZoneProduct />} />
        <Route path="booking/:id" element={<Booking />} />
        <Route path="checkout" element={<Checkout />} />
        <Route path="success" element={<SuccessfulBooking />} />
        <Route path="payment-failed" element={<FailedBooking />} />
        <Route path="reservation" element={<MyPurchases />} />
        <Route index element={<Navigate to="cart" replace={true} />} />
      </Route>
      <Route path="auth" element={<AuthLayout />}>
        <Route path="home" element={<Booking />} />
        <Route path="login" element={<Login />} />
        <Route path="signup" element={<SignUp />} />
        <Route path="otp" element={<Otp />} />
        <Route path="createPin" element={<CreatePin />} />
        <Route path="forgotPassword" element={<ForgotPassword />} />
        <Route path="contest" element={<ComingSoon />} />
        <Route index element={<Navigate to="home" replace={true} />} />
      </Route>
      <Route index element={<Navigate to={"auth"} replace={true} />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default App;
